import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Evaluacion from "./pages/Evaluacion";
import ComoFunciona from "./pages/ComoFunciona";
import Empresas from "./pages/Empresas";
import Nosotros from "./pages/Nosotros";
import Servicios from "./pages/Servicios";
import Admin from "./pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import { LeadDialogProvider } from "@/components/sections/LeadDialog";
import { loadWhatsAppConfig } from "@/lib/whatsapp";

function App() {
  useEffect(() => {
    loadWhatsAppConfig();
  }, []);

  return (
    <div className="App">
      <LeadDialogProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/evaluacion" element={<Evaluacion />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LeadDialogProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
